import React, { useEffect, Suspense } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "../store/actions/index";

import ErrorBoundary from "../hoc/ErrorBoundary.js";

import { withRouter } from "../shared/utility";
import Login from "../views/authentication/Login";
import CampaignProductsDistributed from "../views/campaigns/CampaignProductsDistributed";

function App(props) {
  const { authCheckState } = props;

  useEffect(() => {
    authCheckState();
  }, [authCheckState]);

  let routes = null;

  const authToken = localStorage.getItem("authToken");

  if (authToken && props.isAuthenticated) {
    const campaignId = localStorage.getItem("campaign_id") || "1";
    routes = (
      <Routes>
        <Route path="/" element={<Navigate to={`/campaigns/${campaignId}`} replace />} />
        <Route path="/campaigns/:campaignId" element={<CampaignProductsDistributed />} />
        <Route path="*" element={<Navigate to={`/campaigns/${campaignId}`} replace />} />
      </Routes>
    );
  } else {
    routes = (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <div className="h-full">
      <ErrorBoundary>
        <Suspense fallback={<p>Loading...</p>}>{routes}</Suspense>
      </ErrorBoundary>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.authToken !== null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authCheckState: () => dispatch(actions.authCheckState()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
